export default __webpack_public_path__ + "static/media/Gomathi Shankar Thangamaligai.png.5d0ece6a.png";